import { Navigate, Outlet } from "react-router";
import { CAMPAIGN, useFoodpilotContext, VIEW } from "src/context/FoodpilotContext";

export const CampaignsProtection = () => {
    const { canUser } = useFoodpilotContext();

    if (!canUser(VIEW, CAMPAIGN)) {
        return <Navigate to="/settings" replace />;
    }

    return <Outlet />;
};
